// HAND-MAINTAINED (generator lost) — see note below.
// Source: sampling_config_512_perview.yaml + dataset analysis
//   Front: n=476 views, n=230 inliers   Side: n=386 views, n=309 inliers
// 2026-08-20: the export_pose_gate.py generator is LOST (never committed on
// any branch). This file is now maintained BY HAND against
// sizewall-docs/reference/pose-registry.md — edit both together.
//
// All angles are measured in the same coordinate space as MediaPipe
// normalized landmarks scaled to video pixels (poseFinalWorld in MediaPipe.tsx).
// Angle convention: angleFromVertical = atan2(|dx_px|, dy_px), degrees in
// [0, 180] where 0 = straight down, 90 = horizontal.
//
// Front arm acceptance [15, 50] covers dataset inlier p5–p95 (26.6°–45°) plus
// margin and matches the backend rembg/pose_config.py FRONT_ARM_{MIN,MAX}
// translated to vertical-angle space.

export const POSE_GATE = {
  version: 1,
  front: {
    arm:       { accept: [25.0, 50.0] as [number, number] },
    leg:       { accept: [0.0,  12.0] as [number, number] },
    torsoTilt: { accept: [0.0,  10.0] as [number, number] },
    elbow:     { min: 150 },
  },
  side: {
    arm:       { accept: [0.0,  10.0] as [number, number] },
    leg:       { accept: [0.0,  12.0] as [number, number] },
    // Normalised wrist/elbow offset relative to the trunk segment length.
    // Dataset inlier p95: wrist 0.22, elbow 0.15. Threshold set at p95 + 1σ.
    armInsideBody: { maxWristOverTrunk: 0.20, maxElbowOverTrunk: 0.15 },
    torsoTilt: { accept: [0.0,  10.0] as [number, number] },
    elbow:     { min: 150 },
  },
  flex: {
    upperArm:   { accept: [70.0, 110.0] as [number, number] },  // from vertical; 90 = horizontal
    forearmOutMax: 25.0,   // deg from vertical, tilting away from head
    forearmInMax:  10.0,   // deg from vertical, toward head — overlap risk
    symmetryMax:   15.0,   // |left-right| upper-arm angle
    torsoTilt:  { accept: [0.0, 15.0] as [number, number] },
  },
} as const;
